import { Flex, Box, Text, FormSearchMultipleSelection } from '@shared/components';
import { stringComparator } from '@shared/utils';
export interface ProctorFormFieldProps {
  slotProps?: {
    examDate?: {
      isExamDateSelected: boolean;
    };
    proctor?: {
      mainProctors?: {
        label: string;
        value: string;
      }[];
      isLoading: boolean;
      mainProctorOptions: {
        label: string;
        value: string;
      }[];
    };
  };
}

export default function ProctorFormField(props: Readonly<ProctorFormFieldProps>) {
  const { slotProps } = props;

  const options = slotProps?.proctor?.mainProctorOptions ?? [];

  return (
    <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
      <Box sx={{ width: 240 }}>
        <Text variant='body1Semibold'>ผู้คุมสอบหลัก</Text>
      </Box>
      <Flex sx={{ gap: (theme) => theme.spacing(4), minWidth: '400px', flexDirection: 'column' }}>
        <FormSearchMultipleSelection
          name='mainProctors'
          options={[...options].sort((a, b) => stringComparator(a.label, b.label))}
          label='ผู้คุมสอบประเภทที่ 1'
          loading={slotProps?.proctor?.isLoading}
          placeholder={
            (slotProps?.proctor?.mainProctors ?? []).length > 0 ? '' : 'เลือกผู้คุมสอบประเภทที่ 1'
          }
          disabled={!slotProps?.examDate?.isExamDateSelected}
        />
      </Flex>
    </Flex>
  );
}
